import { upperFirst } from 'lodash';
import { useTranslation } from 'react-i18next';

import {
  StyledErrorLabel,
  StyledErrorMessage,
  StyledErrorWrapper,
} from './Error.styles';
import { IErrorProps } from './Error.types';

const Error = ({ errorMessage }: IErrorProps): JSX.Element => {
  const { t } = useTranslation('errors');

  return (
    <StyledErrorWrapper container>
      <StyledErrorLabel>{upperFirst(t('error'))}</StyledErrorLabel>
      <StyledErrorMessage>{errorMessage}</StyledErrorMessage>
    </StyledErrorWrapper>
  );
};

export default Error;
